/**
 * This file is auto-generated. DO NOT EDIT MANUALLY.
 */

export const configRegistry = {
    bbok: () => import('../config/institutionConfig/bbok.config'),
    default: () => import('../config/institutionConfig/default.config'),
    tcm: () => import('../config/institutionConfig/tcm.config'),
};